// PETG.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function PETG() {
    return (
        <PageLayout title="PETG" subtitle="PETG overview">
            <div className="container flex col box-container">
                {/* <div className="box">PETG</div> */}
            </div>
        </PageLayout>   
    );
}

export default PETG;
